// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2XuRl","top":"styles_top__p4yPU"};